import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import doa from './doaReducer';
import auth from './authReducer';

export default combineReducers({
    form,
    doa,
    auth
});